(ns frontend.view.data-import.steps.errors
  (:require
   [common.localization :as loc]
   [reagent.core :as r]
   [frontend.view.data-import.db :as db]
   [frontend.view.data-import.events :as events]
   [frontend.bootstrap.components :as rbs]
   [clojure.string :as string]
   [frontend.state.current-session :as session]
   [common.util :as cu]
   [ui.components.button.view :as button]))

(defn unknown-value
  [column-name error-data valid-data instructions]
  [:span
   (loc/tr :data-import-error-unknown-values-pre-column)
   [:strong
    (str "\"" column-name "\"")]
   " "
   [:strong.error
    (str error-data)]
   (str
    (loc/tr :data-import-error-unknown-values-post-column)
    " ")
   [:strong.valid
    (str valid-data)]
   (str
    (loc/tr :data-import-error-unknown-values-post-list)
    " "
    instructions)])

(defmulti error-item :error-key)

(defmethod error-item (keyword "Deal Contacts")
  [data]
  (let [error-data (:error-data data)]
    error-data))

(defmethod error-item :entity.type/oppo
  [data]
  (let [error-data (:error-data data)]
    (str (loc/tr (:error-key data)) " - " error-data)))

(defmethod error-item :entity.type/company
  [data]
  (let [error-data (:error-data data)]
    (str (loc/tr (:error-key data)) " - " error-data)))

(defmethod error-item :entity.type/fof-asset
  [data]
  (let [error-data (:error-data data)]
    (str (loc/tr (:error-key data)) " - " error-data)))

(defmethod error-item :entity.type/person
  [data]
  (let [error-data (:error-data data)]
    (str (loc/tr (:error-key data)) " - " error-data)))

(defmethod error-item :deal-contact-association
  [data]
  (let [error-data (:error-data data)]
    (str (loc/tr (:error-key data)) " - " error-data)))

(defmethod error-item :investor-contact-association
  [data]
  (let [error-data (:error-data data)]
    (str (loc/tr (:error-key data)) " - " error-data)))

(defmethod error-item :froppo-contact-association
  [data]
  (let [error-data (:error-data data)]
    (str (loc/tr (:error-key data)) " - " error-data)))

(defmethod error-item :holding-contact-association
  [data]
  (let [error-data (:error-data data)]
    (str (loc/tr (:error-key data)) " - " error-data)))


(defmethod error-item :company-contact-association
  [data]
  (let [error-data (:error-data data)]
    (str (loc/tr (:error-key data)) " - " error-data)))

(defmethod error-item :sheet-columns
  [data]
  (loc/tr :data-import-error-tampered-columns))

(defmethod error-item :data-type
  [data]
  (let [error-data (:error-data data)]
    [:ul
     (->> (take (min 25 (count error-data)) error-data)
          (map-indexed (fn [idx e]
                         [:li
                          {:key (str (:error-key data) "-" idx)}
                          (if (or (map-entry? e)
                                  (coll? e))
                            [:div
                             [:span.error-cell
                              (or (key e)
                                  (first e))]
                             [:span
                              (str (or (val e)
                                       (second e)))]]
                            [:span (str e)])]))
          (doall))
     (when (> (count error-data) 25)
       [:li {:key (str (:error-key data) "-more-items")}
        (loc/tr :more-items [(- (count error-data) 25)])])]))

(defmethod error-item :invalid-data
  [data]
  (let [error-data (:error-data data)]
    [:ul
     (->> (take (min 25 (count error-data)) error-data)
          (map-indexed (fn [idx e]
                         [:li
                          {:key (str (:error-key data) "-" idx)}
                          (cond
                            (and (coll? e)
                                 (= (count e) 2)
                                 (keyword? (first e)))
                            [:div [:span.error-cell (name (first e))]
                             [:span (str (second e))]]
                            (map-entry? e)
                            [:div [:span.error-cell (key e)]
                             [:span (val e)]]
                            :else
                            [:span (str e)])]))
          (doall))
     (when (> (count error-data) 25)
       [:li {:key (str (:error-key data) "-more-items")}
        (loc/tr :more-items [(- (count error-data) 25)])])]))

(defmethod error-item :default
  [data]
  [:label (str data)])

(defmethod error-item :columns
  [data]                       ;; tampered
  [:label (loc/tr :data-import-error-tampered-columns)])

(defmethod error-item :tags
  [data]
  [:label (loc/tr :data-import-error-missing-tags)
   (str (:error-data data))])

(defmethod error-item :persons
  [data]
  [:span (loc/tr :data-import-error-persons-text)])

(defmethod error-item :companies
  [data]
  [:label (loc/tr :data-import-error-missing-companies-pre)
   [:strong (str "\"" (loc/tr :asset/name) "\"")]
   (loc/tr :data-import-error-missing-companies-post)])

(defmethod error-item :fof-assets
  [data]
  [:label (loc/tr :data-import-error-missing-fof-assets-pre)
   [:strong (str "\"" (loc/tr :asset/name) "\"")]
   (loc/tr :data-import-error-missing-fof-assets-post)])

(defmethod error-item :pass-reason-missing
  [data]
  [:span
   [:strong
    (loc/tr :data-import-error-missing-pass-reason-bold)]
   [:span (loc/tr :data-import-error-missing-pass-reason-pre-row-numbers)]
   #_(str (:error-data data))
   [:span (loc/tr :data-import-error-missing-pass-reason-post-row-numbers)]])

(defmethod error-item :pass-date-missing
  [data]
  [:span
   [:strong
    (loc/tr :data-import-error-missing-pass-date-bold)]
   [:span (loc/tr :data-import-error-missing-pass-date-pre-row-numbers)]
   #_(str (:error-data data))
   [:span (loc/tr :data-import-error-missing-pass-date-post-row-numbers)]])

(defmethod error-item :pass-reasons
  [data]
  (let [pass-reason-names (->> (session/non-archived-named-values :oppo/pass-reason-v2 nil)
                               (map :named-value/value))
        instructions (loc/tr :data-import-error-unknown-values-instructions-pass-reasons)]
    (unknown-value (loc/tr :oppo/pass-reason-v2) (:error-data data) pass-reason-names instructions)))

(defmethod error-item :stages
  [data]
  (let [stage-names (->> @session/all-stages
                         (remove :common/disabled?)         ;TODO: Should these be filtered by pipeline?
                         (map :stage/name))
        instructions (loc/tr :data-import-error-unknown-values-instructions-stages)]
    (unknown-value (loc/tr :oppo/stage) (:error-data data) stage-names instructions)))

(defmethod error-item :accounts
  [data]
  (let [label (loc/tr :oppo/owner)
        names (->> @session/all-accounts
                   ;;TODO only active-tenant-accounts? now includes guests
                   (filter (fn [[id acct]]
                             (not= (:account/first-name acct) "system")))
                   (map (fn [[id acct]]
                          (str (:account/first-name acct)
                               " "
                               (:account/last-name acct)))))
        instructions (loc/tr :data-import-error-unknown-values-instructions-accounts)]
    (unknown-value label (:error-data data) names instructions)))

(defmethod error-item :data-types
  [data]
  [:span
   (loc/tr :data-import-error-datatype-pre)
   [:strong.error
    (string/join ", "
                 (doall (->> (:error-data data)
                             (map (fn [err-item]
                                    (doall (map (fn [k]
                                                  (loc/tr k))
                                                (keys err-item)))))
                             (distinct))))]
   (loc/tr :data-import-error-datatype-post)])

(defmethod error-item :duplicate-names
  [data]
  [:span
   (loc/tr :data-import-error-duplicate-pre)
   "["
   [:strong
    (string/join ", " (:error-data data))] "]"
   (loc/tr :data-import-error-duplicate-post)])

(defmethod error-item :oppos
  [data]
  [:span
   [:strong
    (loc/tr :data-import-error-oppos)]
   (loc/tr :data-import-error-oppos-pre)
   [:strong.error
    (string/join ", "
                 (doall (map (fn [err-item]
                               (loc/tr (keyword err-item)))
                             (-> (:error-data data)
                                 flatten
                                 distinct))))
    (loc/tr :data-import-error-oppos-post)]])

(defn default-error
  [key error-items]
  [:span
   [:label (loc/tr (keyword key))]
   [:ul.error-item-details
    [:label
     (case (keyword key)
       :columns (loc/tr :data-import-error-tampered-columns)
       :tags (loc/tr :data-import-error-tags-missing)
       :pass-reason (loc/tr :data-import-error-missing-pass-reason)
       :pass-date (loc/tr :data-import-error-missing-pass-date)
       :companies (loc/tr :data-import-error-company-name-missing-for-items)
       :fof-assets (loc/tr :data-import-errror-fof-asset-name-missing-for-items)
       :accounts (loc/tr :data-import-error-accounts-missing)
       (str " '" key " '"))]
    (doall (for [item (take (min 25 (count error-items)) error-items)]
             [:li.error-item-details-item
              {:key
               (str "data-import-error-" item)}
              (str item)]))]])

(defn view
  []
  (let [error-response (:import-error-response @db/import-state)
        errors (:errors error-response)
        file-url (:file-url error-response)]
    [:div.import-container
     [:div
      {:class-name "container settings2-view narrow"}
      [:ul.error-items
       (if errors
         (let [err-keys (keys errors)]
           (->> errors
                (map (fn [[sheet sheet-errors]]
                       [:li {:key sheet}
                        [:h2 sheet]
                        [:ul.error-items
                         (->> (take (min 25 (count sheet-errors)) sheet-errors)
                              (map (fn [[error-key error-data]]
                                     [:li.error-item
                                      {:key error-key}
                                      [error-item
                                       {:error-key  error-key
                                        :error-data error-data}]])))]]))
                (doall)))
         [:li.error-item
          {:key "dataimport-generic-error"}

          [:span (loc/tr :data-import-error-generic-text)]
          [:a
           {:href   "mailto:support@zapflow.com"
            :target "_blank"}
           "support@zapflow.com"]])]
      (when file-url
        [:div
         {:class "grid gap-4"}
         [:div
          [:span
           {:class "pt-3 block text-center text-neutral-700"}
           [:a.text-theme
            {:href file-url}
            "Download"] " excel with highlighted errors"]]])
      [:div
       {:class-name "d-flex justify-content-center mt-4 mb-4"}
       [button/primary-solid
        {:on-click   #(events/set-step! :import-step-intro)}
        (loc/tr :import-step-start-over-button)]]]]))
